/* eslint-disable multiline-ternary */
import React from 'react';
import Modal from 'antd/es/modal/Modal';
import { Grid } from 'antd';
import ReactPlayer from 'react-player';

const UserVideoModal = (props) => {
  const screens = Grid.useBreakpoint();
  const modalHeight = screens.xs ? '45vh' : screens.sm ? '75vh' : '90vh';

  return (
    <>
      <Modal
        visible={props.videoModalVisible}
        onOk={() => {
          props.setVideoModalVisible(false);
        }}
        onCancel={() => {
          props.setVideoModalVisible(false);
        }}
        centered
        width={screens.xs ? '100%' : '80%'}
        bodyStyle={{
          padding: 0,
          height: modalHeight,
          backgroundColor: 'transparent'
        }}
        footer={null}
      >
        <div
          style={{
            flex: 1,
            width: '100%',
            height: '100%',
            margin: 0,
            padding: 0
          }}
        >
          <ReactPlayer
            url={props.video}
            controls
            width='100%'
            height={modalHeight}
          />
        </div>
      </Modal>
    </>
  );
};

export default UserVideoModal;
